import { X, Check } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";


const ComparisonModal = ({ plans, isOpen, onClose, isYearly,currency }) => {
  const allFeatures = Array.from(
    new Set(plans.flatMap((plan) => plan.features.map((f) => f.name)))
  );

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
        <DialogTitle className="text-2xl font-bold ">
          Compare All Plans
        </DialogTitle>

        <div className="mt-6">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-4 px-4 font-semibold text-lg">
                    Features
                  </th>
                  {plans.map((plan) => {
                    const isFree = plan.name === "Free";
                    const teamPrice = isFree
                      ? 0
                      : currency === "INR"
                      ? plan.team_inr
                      : plan.team_usd;

                    const staffPrice = isFree
                      ? 0
                      : currency === "INR"
                      ? plan.staff_inr
                      : plan.staff_usd;

                    let totalPrice = teamPrice;
                    if (isYearly) {
                      totalPrice = teamPrice * 12 * 0.8; // yearly with 20% discount
                    }

                    const formatPrice = (price) =>
                      currency === "INR"
                        ? `₹${price.toLocaleString("en-IN")}`
                        : `$${price.toFixed(2)}`;

                    return (
                      <th
                        key={plan.name}
                        className="text-center py-4 px-4 min-w-[180px]"
                      >
                        <div className="space-y-2">
                          <div className="text-3xl font-extrabold text-gray-900">
                            {isFree ? "Free" : formatPrice(totalPrice)}
                          </div>
                          {!isFree && (
                            <div className="text-xs text-gray-500">
                              {isYearly ? "per year (20% off)" : "per month"}
                            </div>
                          )}
                          <div className="font-bold text-lg">{plan.name}</div>
                          <div className="text-sm text-gray-600">
                            {plan.description}
                          </div>
                          {plan.mostPopular && (
                            <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                              Most Popular
                            </span>
                          )}
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {allFeatures.map((featureName, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-4 font-medium">{featureName}</td>
                    {plans.map((plan) => {
                      const feature = plan.features.find(
                        (f) => f.name === featureName
                      );
                      return (
                        <td key={plan.name} className="py-3 px-4 text-center">
                          {feature ? (
                            <div className="flex flex-col items-center space-y-1">
                              {feature.included ? (
                                <Check className="w-5 h-5 text-green-500" />
                              ) : (
                                <X className="w-5 h-5 text-gray-400" />
                              )}
                              {feature.addon && (
                                <span className="text-xs text-blue-600">
                                  {feature.addon}
                                </span>
                              )}
                            </div>
                          ) : (
                            <X className="w-5 h-5 text-gray-400 mx-auto" />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ComparisonModal;
